<!-- Header wrapper -->
<form [formGroup]="tenantGridForm">
  <div class="cc-content-header-panel d-flex justify-content-between align-items-center">
    <!--Title-->
    <h3>{{'_General_Clients_Text_' | translate }}</h3>
    <button *ngIf="userPermissionList?.includes(25)" id="addClient" type="button" class="btn btn-primary"
      (click)="goToTenantCreation()">{{'_General_Add_Client_Text_' | translate }}</button>
  </div>

  <div class="cc-content-wrapper">
    <!--Action Panel-->
    <div class="cc-action-panel row justify-content-end">
      <!--Search with close-->
      <div class="cc-search with-close">
        <input id="tenantSearchText" [(ngModel)]="searchTextValue" placeholder="{{'_General_Search_Text_' | translate }}" class="form-control"
          (keydown.enter)="search()" formControlName="searchClient" />
        <button id="tenantSearchButton" class="cc-search-btn" (click)="search()"><span
            class="fas fa-search"></span></button>
        <button *ngIf="searchTextValue" [ngClass]="{ 'show-btn': searchTextValue !== '' }" class="cc-close-btn"
          (click)="onClearSearchTextClicked()">
          <span class="fas fa-times"></span>
        </button>
      </div>
    </div>

    <!-- Client Grid Wrapper -->
    <div class="localization-checklists-permission-clients-grid-wrapper-grid-wrapper">
      <!-- Grid  -->
      <kendo-grid id="tenant-grid" [kendoGridBinding]="tenantGridSource" [pageSize]="pageInfo.PageSize"
        [skip]="(pageInfo.Page - 1) * pageInfo.PageSize" [pageable]="true"
        [sortable]="{allowUnsort: false, mode: 'single'}" [scrollable]="'scrollable'" [sort]=" sort"
        (pageChange)="onPageChange($event)">
        <kendo-grid-messages pagerFirstPage="{{'_Go_To_First_Page_Text_' | translate}}" pagerLastPage="{{'_Go_To_Last_Page_Text_' | translate}}" pagerNextPage="{{'_Go_To_Next_Page_Text_' | translate}}" pagerPreviousPage="{{'_Go_To_Previous_Page_Text_' | translate}}" pagerPage="{{'_Page_Grid_Text_' | translate}}" noRecords="{{'_NoRecords_Grid_Text_' | translate}}" pagerItems="{{'_General_Kendo_Grid_Pageable_Items_Text_' | translate}}" pagerOf="{{'_General_Kendo_Grid_Pageable_Of_Text_' | translate}}"></kendo-grid-messages>
        <kendo-grid-column field="tenantName" title="{{'_General_Client_Name_Text_' | translate }}" [headerStyle]="{'font-weight' : 'bold'}">
        </kendo-grid-column>
        <kendo-grid-column field="tenantCode" title="{{'_General_Client_Code_Text_' | translate }}"  [headerStyle]="{'font-weight' : 'bold'}">
        </kendo-grid-column>
        <kendo-grid-column field="solutionId" title="{{'_General_Solution_Id_Text_' | translate }}" [headerStyle]="{'font-weight' : 'bold'}">
        </kendo-grid-column>
        <kendo-grid-column field="serverName" title="{{'_General_Server_Name_Text_' | translate }}" [headerStyle]="{'font-weight' : 'bold'}">
        </kendo-grid-column>
        <kendo-grid-column field="databaseName" title="{{'_General_Database_Name_Text_' | translate }}" [headerStyle]="{'font-weight' : 'bold'}">
        </kendo-grid-column>
      </kendo-grid>
    </div>
  </div>
</form>
